import './dice.scss';
import { useState } from 'react';

type DiceProps = {
    nbSides: number;
    isMaster?: boolean;
};

function Dice(props: DiceProps) {
    const [diceValue, setDiceValue] = useState<number>(-1);
    const [isRolling, setIsRolling] = useState<boolean>(false);

    let count = 0;
    const maxCount = 10;
    let interval = 30;

    function getRandomNumber(): number {
        return Math.floor(Math.random() * props.nbSides) + 1;
    }

    function diceRoll() {
        count++;

        setDiceValue(getRandomNumber());

        if (count <= maxCount) {
            setIsRolling(true);
            interval += count * interval * 0.05;
            setTimeout(diceRoll, interval);
        } else {
            setIsRolling(false);
        }
    }

    return (
        <div className="dice-box">
            <div className={isRolling ? "dice rolling" : "dice"} onClick={() => isRolling ? void (0) : diceRoll()}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 345.23 344.67"><g ><polygon fill="#ec672a" points="196.6 344.67 67.95 300.64 225.59 297.3 196.6 344.67" /><polygon fill="#ec672a" points="300.44 67.41 332.85 183.44 297.54 105.77 300.44 67.41" /><polygon fill="#ec672a" points="239.46 285.22 345.23 229.68 294.15 117.34 239.46 285.22" /><polygon fill="#ec672a" points="231.13 285.38 113.63 150.2 287.66 111.82 231.13 285.38" /><polygon fill="#ec672a" points="294.05 47.51 290.16 98.9 168.3 4.62 294.05 47.51" /><polygon fill="#ec672a" points="149.46 0 111.73 142.55 284.48 104.46 149.46 0" /><polygon fill="#ec672a" points="140.39 3.52 103.56 142.78 2.58 110.69 140.39 3.52" /><polygon fill="#ec672a" points="46.36 284.98 101.06 150.25 0 118.13 46.36 284.98" /><polygon fill="#ec672a" points="107.55 155.2 224.23 289.44 51.56 293.1 107.55 155.2" /><polygon fill="#ec672a" points="212.91 333.1 235.51 296.18 312.76 255.61 212.91 333.1" /></g></svg>
            </div>
            <div className={isRolling ? "result rolling" : "result"}>
                {diceValue === -1 ? "-" : diceValue}
            </div>
        </div>
    );
}

export default Dice;